import { addDays, format, startOfWeek } from "date-fns";
import { it } from "date-fns/locale/it";

export interface IWeekModel {
    label: string;
    year_label: string;
    start: Date;
    end: Date;
    week: string;
    startDay: string;
    startMonth: string;
    endDay: string;
    endMonth: string;
}

export const weekFactory = (date?: Date) => {
    const _date = date ? date : new Date();
    const start = startOfWeek(_date, { weekStartsOn: 1 }); // Monday start
    const end = addDays(start, 6);
    return {
        label: `${format(start, "d MMMM", { locale: it })} – ${format(end, "d MMMM", { locale: it })}`, // Full weekday name
        year_label: format(start, "yyyy", { locale: it }),
        start: start,
        startDay: format(start, "d", { locale: it }),
        startMonth: format(start, "MMMM", { locale: it }),
        week: format(start, "yyyy-MM-dd"),
        end: end,
        endDay: format(end, "d", { locale: it }),
        endMonth: format(end, "MMMM", { locale: it }),
    } as IWeekModel;
};
